module.exports = __webpack_public_path__ + "img/if_graduation-cap_3688484.c7d4ca69.png";